import { common } from "@mui/material/colors";

export const glowShadowGreenButtonSx = {
  position: "relative",
  background: "linear-gradient(90deg, #2a9e7c 0%, #065A5C 93%) !important",
  color: "#fff",
  textTransform: "none",
  borderRadius: "20px",
  px: 3,
  py: 1,
  boxShadow: "0px 0px 22px 10px rgba(42, 138, 115, 0.6)",
  transition: "box-shadow 0.3s ease, transform 0.2s ease",
  overflow: "hidden",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent) !important",
    transition: "left 0.9s ease"
  },

  "&:visited": { color: common.white },

  "&:active": {
    color: common.white
  },

  "&:hover": {
    boxShadow: "0px 0px 10px 10px rgba(42, 138, 115, 0.4) !important",
    background: "linear-gradient(90deg, #065A5C 7%, #2a9e7c 100%) !important",

    "&::before": {
      left: "100%"
    }
  }
};

export const glowBlueShadowSx: any = {
  boxShadow: "0px 0px 10px 10px rgba(15, 136, 202, 0.5)",
  "&:hover": {
    boxShadow: "0px 0px 7px 7px rgba(15, 136, 202, 0.3)"
  }
};

export const trialOrangeShadowSx: any = {
  border: "2px solid #ff9800", // Orange border for trial
  background:
    "linear-gradient(135deg, hsla(273, 21%, 54%, 0.85) 0%, hsla(30, 100%, 65%, 0.6) 100%)",
  "&:hover": {
    background:
      "linear-gradient(135deg, hsla(273, 21%, 54%, 1) 0%, hsla(30, 100%, 65%, 0.5) 100%)",
    boxShadow: "0 0 12px rgba(255, 152, 0, 0.4)"
  }
};
